import { nextTick, computed } from 'vue'

export function usePaginationActions(props, emit, scrollTarget, totalPages) {
  const goToPage = async (page) => {
    if (page < 1 || page > totalPages.value || page === props.currentPage || props.loading) {
      return
    }
    
    emit('update:currentPage', page)
    emit('page-change', page)
    
    await nextTick()
    
    if (scrollTarget?.value) {
      setTimeout(() => {
        if (scrollTarget?.value) {
          scrollTarget.value.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 150)
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  const handleItemsPerPageChange = async (value) => {
    const newItemsPerPage = parseInt(value)
    emit('update:itemsPerPage', newItemsPerPage)
    emit('items-per-page-change', newItemsPerPage)
    
    const newTotalPages = Math.ceil(props.total / newItemsPerPage)
    if (props.currentPage > newTotalPages) {
      const newPage = Math.max(1, newTotalPages)
      emit('update:currentPage', newPage)
      emit('page-change', newPage)
    }
    
    await nextTick()
    if (scrollTarget?.value) {
      setTimeout(() => {
        scrollTarget.value.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
    } else {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 100)
    }
  }

  return {
    goToPage,
    handleItemsPerPageChange
  }
}
